"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusEnum = void 0;
const datahubEvents_1 = require("modules/app/services/datahubEvents");
const getStatusEnum = (status) => {
    let schemaStatus = datahubEvents_1.EventCommentStatus.APPROVE;
    if (status === datahubEvents_1.CommentStatusForUpdate.DISAPPROVED) {
        schemaStatus = datahubEvents_1.EventCommentStatus.HIDDEN;
    }
    if (status === datahubEvents_1.CommentStatusForUpdate.SPAM_CONFIRMED ||
        status === datahubEvents_1.CommentStatusForUpdate.SPAM) {
        schemaStatus = datahubEvents_1.EventCommentStatus.SPAM_CONFIRMED;
    }
    return schemaStatus;
};
exports.getStatusEnum = getStatusEnum;
